import React, { useCallback, useState } from 'react';
import { useLocation } from '@reach/router';

import allLocales from '~translations/locales';
import localesEnUs from '~translations/messages/en-us.json';
import localesHyAm from '~translations/messages/hy-am.json';
// import localesRuRu from '~translations/messages/ru-ru.json';

import TranslationContext from './TranslationContext';
import { TranslationDataType } from './types';

interface PropsTypeInterface {}

const locales = Object.keys(allLocales) as Array<AppLocaleType>;
const translations = {
  'en-us': localesEnUs,
  'hy-am': localesHyAm,
  // 'ru-ru': localesRuRu,
};

function TranslationProvider(
  props: PropsType<PropsTypeInterface>,
): ReactRenderType {
  const { pathname } = useLocation();
  const defaultLang = Object.keys(allLocales).filter(
    (lang: AppLocaleType) => allLocales[lang].default,
  )[0];

  const urlLang = pathname.split('/')[1];
  const currentLang: string = Object.keys(allLocales)
    .map((lang: AppLocaleType) => allLocales[lang].path)
    .includes(urlLang)
    ? urlLang
    : defaultLang;

  const [appLocale, setAppLocale] = useState<AppLocaleType>(
    currentLang as AppLocaleType,
  );

  const setLocale = useCallback((newLang: AppLocaleType) => {
    if (newLang) {
      setAppLocale(newLang);
    }
  }, []);

  const translate = useCallback(
    (
      locale: AppLocaleType,
      translationKey: string,
      data: TranslationDataType = {},
    ) => {
      let translated = translations?.[locale]?.[translationKey];
      if (!translated) {
        return translationKey;
      }

      for (const search in data) {
        const pattern = new RegExp('{{' + search + '}}', 'g');
        const replaceTo = data[search] as string;

        translated = translated.replace(pattern, replaceTo);
      }

      return translated;
    },
    [],
  );

  const t = useCallback(
    (translationKey: string, data: TranslationDataType = {}) =>
      translate(appLocale, translationKey, data),
    [appLocale],
  );

  return (
    <TranslationContext.Provider
      value={{
        locales: locales,
        locale: appLocale,
        setLocale,
        t,
        translate,
      }}
    >
      {props.children}
    </TranslationContext.Provider>
  );
}

export default TranslationProvider;
